import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getAssignationManagementResidueFinalDestinationList,
	addNewAssignationManagementResidueFinalDestination,
	updateAssignationManagementResidueFinalDestination,
	deleteAssignationManagementResidueFinalDestination,
	getAssignationManagementResidueFinalDestination,
	registerAssignationManagementResidueFinalDestination
} from './thunk';

export const initialState = {
	itemAssignationManagementResidueFinalDestinationList: [],
	itemAssignationManagementResidueFinalDestinationDetail: null,
	isAssignationManagementResidueFinalDestinationLoading: false,
	isAssignationManagementResidueFinalDestinationSuccess: false,

	dataAssignationManagementResidueFinalDestination: null,
	assignationManagementResidueFinalDestinationList: [],
	assignationManagementResidueFinalDestinationListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	isReceiving: false,
	isReceived: false,
	isReceptionError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false
};

const AssignationManagementResidueFinalDestinationSlice = createSlice({
	name: 'AssignationManagementResidueFinalDestinations',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setRequireReloadSelectionItemsGrid(state, action) {
			state.requireReloadSelectionItemsGrid = action.payload;
		},
		cleanDataAssignationManagementResidueFinalDestination(state, action) {
			state.dataAssignationManagementResidueFinalDestination = null;
		},
		restartRegisterAssignationManagementResidueFinalDestination(state, action) {
			state.isAdding = false;
			state.isAdded = false;
			state.registerDisabled = false;
		},
	},
	extraReducers: builder => {
		builder.addCase(getAssignationManagementResidueFinalDestination.fulfilled, (state, action) => {
			state.isAssignationManagementResidueFinalDestinationLoading = false;
			state.isAssignationManagementResidueFinalDestinationSuccess = true;
			state.itemAssignationManagementResidueFinalDestinationDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getAssignationManagementResidueFinalDestination.pending, state => {
			state.isAssignationManagementResidueFinalDestinationLoading = true;
			state.isAssignationManagementResidueFinalDestinationSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getAssignationManagementResidueFinalDestination.rejected, (state, action) => {
			state.isAssignationManagementResidueFinalDestinationLoading = false;
			state.isAssignationManagementResidueFinalDestinationSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getAssignationManagementResidueFinalDestinationList.pending, state => {
			state.isAssignationManagementResidueFinalDestinationSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getAssignationManagementResidueFinalDestinationList.fulfilled, (state, action) => {
			state.itemAssignationManagementResidueFinalDestinationList = action.payload;
			state.assignationManagementResidueFinalDestinationList = action.payload;
			state.isLoadingList = false;
			state.isAssignationManagementResidueFinalDestinationSuccess = true;

			let assignationManagementResidueFinalDestinationListSelect = [];
			action.payload.map(item =>
				assignationManagementResidueFinalDestinationListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.assignationManagementResidueFinalDestinationListSelect = assignationManagementResidueFinalDestinationListSelect;
		});
		builder.addCase(getAssignationManagementResidueFinalDestinationList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAssignationManagementResidueFinalDestinationSuccess = true;
		});
		builder.addCase(addNewAssignationManagementResidueFinalDestination.fulfilled, (state, action) => {
			state.itemAssignationManagementResidueFinalDestinationList.push(action.payload);
			state.assignationManagementResidueFinalDestinationList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewAssignationManagementResidueFinalDestination.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewAssignationManagementResidueFinalDestination.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateAssignationManagementResidueFinalDestination.fulfilled, (state, action) => {
			state.itemAssignationManagementResidueFinalDestinationList = state.itemAssignationManagementResidueFinalDestinationList.map(assignationManagementResidueFinalDestination =>
				assignationManagementResidueFinalDestination.assignationManagementResidueFinalDestinationname === action.payload.old_assignationManagementResidueFinalDestination
					? { ...assignationManagementResidueFinalDestination, ...action.payload.updated_assignationManagementResidueFinalDestination }
					: assignationManagementResidueFinalDestination
			);
			state.assignationManagementResidueFinalDestinationList = state.assignationManagementResidueFinalDestinationList.map(assignationManagementResidueFinalDestination =>
				assignationManagementResidueFinalDestination._id.toString() === action.payload._id.toString()
					? { ...assignationManagementResidueFinalDestination, ...action.payload }
					: assignationManagementResidueFinalDestination
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateAssignationManagementResidueFinalDestination.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateAssignationManagementResidueFinalDestination.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteAssignationManagementResidueFinalDestination.fulfilled, (state, action) => {
			state.itemAssignationManagementResidueFinalDestinationList = current(state.itemAssignationManagementResidueFinalDestinationList).filter(
				item => item._id !== action.payload._id
			);
			state.assignationManagementResidueFinalDestinationList = current(state.assignationManagementResidueFinalDestinationList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteAssignationManagementResidueFinalDestination.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteAssignationManagementResidueFinalDestination.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		builder.addCase(registerAssignationManagementResidueFinalDestination.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(registerAssignationManagementResidueFinalDestination.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(registerAssignationManagementResidueFinalDestination.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
	},
});

export const {
	setRequireCloseModal,
	setRequireReloadSelectionItemsGrid,
	cleanDataAssignationManagementResidueFinalDestination,
	restartRegisterAssignationManagementResidueFinalDestination
} = AssignationManagementResidueFinalDestinationSlice.actions;

export default AssignationManagementResidueFinalDestinationSlice.reducer;
